<template>
  <v-card>
    <delete-dialog
      @success="deleteInvoice"
      :confirm-loading="deleteConfirmLoading"
      @closeDialog="cancelDelete"
      :dialog="delete_dialog"
      title="Invoice"
    ></delete-dialog>
    <!--        
        <v-row>
            <v-col cols="12 pl-10">
                <router-link class="profile-link" :exact="true" :to="{name: 'AddInvoice'}">
                    <v-btn color="#6A158E" dark>Create Invoice</v-btn>
                </router-link>
            </v-col>
        </v-row>

-->
    <v-row>
      <v-col
        sm="5"
        md="4"
        lg="4"
        offset-lg="8"
        offset-md="8"
        offset-sm="7"
        cols="12 pl-10 pr-10"
      >
        <AccountMonthlySearch @changeYear="searchByYear" @change="searchByMonth" />
      </v-col>
    </v-row>

    <v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="mdi-magnify"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
    </v-card-title>
    <v-data-table :page.sync="page" :items="items" :headers="headers" :search="search">
      <template v-slot:item.student_invoice_id="{ item }">
        <span class="table-complete-name">QSL_{{ item[0].student_invoice_id }}</span>
      </template>
      <template v-slot:item.students="{ item }">
        <!-- <span class="table-complete-name">{{item.student.id}}</span> -->
        <div v-for="student in item">
          <!-- <div v-for="student in students"> -->
          <p>{{ student.student.std_fname }} {{ student.student.std_lname }}</p>
          <!-- </div> -->
        </div>
      </template>
      <template v-slot:item.classes="{ item }">
        <!-- <span class="table-complete-name">{{item.student.id}}</span> -->
        <div v-for="student in item">
          <!-- <div v-for="student in students"> -->
          <p>{{ student.class.class_name }}</p>
          <!-- </div> -->
        </div>
      </template>
      <template v-slot:item.total_hours="{ item }">
        <!-- <span class="table-complete-name">{{item.student.id}}</span> -->
        <div v-for="student in item">
          <!-- <div v-for="student in students"> -->
          <p>{{ student.total_hours }}</p>
          <!-- </div> -->
        </div>
      </template>
      <template v-slot:item.created_at="{ item }">
        <p>{{ item[0].created_at }}</p>
      </template>
      <template v-slot:item.amount="{ item }">
        <!-- <span class="table-complete-name">{{item.student.id}}</span> -->
        <div v-for="student in item">
          <!-- <div v-for="student in students"> -->
          <p>£ {{ student.amount }}</p>
          <!-- </div> -->
        </div>
      </template>

      <template v-slot:item.action="{ item }">
        <a
          :href="`${getBaseURL}/view/invoice/${item[0].student_invoice_id}`"
          target="_blank"
          v-if="perms.earn_view"
        >
          <v-icon color="red">mdi-eye</v-icon>
        </a>
      </template>
      <!--
            <template v-slot:item.action="{ item }">
                    <router-link class="profile-link" active-class :exact="true" :to="{name: 'EditInvoice',params:{id:item.student_invoice_id}}">
                    <v-icon color="success">mdi-file-edit</v-icon>
                </router-link>
                 <v-icon color="red" @click.stop="confirmDelete(item)">mdi-delete</v-icon> 
                <a :href="url+'view/invoice/'+item[0].student_invoice_id" target="_blank"><v-icon color="red">mdi-eye</v-icon></a>
                <a :href="url+'send/invoice/'+item[0].student_invoice_id" target="_blank"><v-icon color="red">mdi-send</v-icon></a>
            </template>
            -->
    </v-data-table>
  </v-card>
</template>

<script>
import DataTableMixin from "../../mixins/dataTable";
import DeleteRow from "../../mixins/deleteRow";
import DeleteDialog from "../Dialogs/DeleteDialog";
export default {
  props: ["status", "counter","perms"],
  name: "EarningTable",
  components: {
    DeleteDialog,
  },
  mixins: [DataTableMixin, DeleteRow],
  watch: {
    counter: function (val) {
      //console.log(this.items);
      this.getItems();
    },
  },
  computed: {
    getBaseURL(url) {
      return window.baseURL;
    },
  },
  data() {
    return {
      search: "",
      url: process.env.VUE_APP_BASE_URL,
      delete_dialog: false,
      page: 1,
      pageCount: 3,
      itemsPerPage: 10,
      headers: [
        // {text: "Srno.", sortable: true, value: "id"},
        {
          text: "Invoice No.",
          value: "student_invoice_id",
          sortable: false,
        },
        // {text: "Student ID", sortable: true, value: "student_id"},
        {
          text: "Student Name",
          value: "students",
          sortable: true,
        },
        {
          text: "Class.",
          value: "classes",
          sortable: false,
        },
        {
          text: "Created At",
          value: "created_at",
          sortable: false,
        },
        // {text: "Joining Date", value: "created_at", sortable: false},
        // {text: "Start Date", value: "start_date", sortable: false},
        // {text: "End Date", value: "end_date", sortable: false},
        {
          text: "Total Hours",
          value: "total_hours",
          sortable: false,
        },
        {
          text: "Amount",
          value: "amount",
          sortable: false,
        },
        {
          text: "Action",
          value: "action",
          sortable: false,
        },
        //{text: "Action", value: "action", sortable: false}
      ],
    };
  },
  methods: {
    deleteInvoice() {
      // console.log("deleting")
      this.deleteConfirmLoading = true;
      axios
        .delete(apiRoutes.accounts.invoices.students.url + this.current_row.id)
        .then((response) => {
          this.getItems();
          this.deleteConfirmLoading = false;
          this.delete_dialog = false;
        })
        .catch((error) => {});
    },
    getZeroAddedNum(num) {
      return num.toString().padStart(2, "0");
    },
    getItems(month = null, year = null) {
      this.loading = true;
      axios
        .get(apiRoutes.accounts.invoices.students.url, {
          params: {
            ...this.formQueryParams(),
            month: month,
            year: year,
            status: this.status,
          },
        })
        .then((response) => {
          this.items = response.data;
          this.loading = false;
        });
    },
    searchByMonth(val) {
      this.getItems(val);
    },
    searchByYear(val) {
      this.getItems(null, val);
    },
  },
  mounted() {
    this.getItems();
  },
};
</script>

<style lang="scss">
.v-data-table-header th span {
  font: 300 14px Gotham;
  font-family: "Gotham Narrow";
  color: #8898aa;
}

.table-complete {
  &-srno {
    font: 500 14px/13px Gotham;
    color: #172b4d;
  }

  &-name {
    display: block;
    font: 500 14px/13px Gotham;
    color: #6a158e;
  }

  &-student_id {
    font: 500 14px/13px Gotham;
    color: #0ebddff7;
  }

  &-time {
    display: block;
    font: 400 14px/10px Gotham;
    color: #0e0edff7;
  }

  &-days {
    font: 400 14px/15px Gotham;
    color: #172b4db3;
  }

  &-session {
    font: 500 14px/13px Gotham;
    color: #f0cb00;
  }
}
</style>
